import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeTeachers = data => {
  const teacher = new schema.Entity(
    'teachers',
    {},
    { idAttribute: teacher => teacher.account.id }
  )
  return normalize(data, [teacher])
}

const normalizePendingTeachers = data => {
  const pending_teacher = new schema.Entity(
    'pending_teachers',
    {},
    { idAttribute: pending_teacher => pending_teacher.account.id }
  )
  return normalize(data, [pending_teacher])
}

const SchoolTeam = combineReducers({
  fetchSchoolTeamRequest: createRequestReducer('SCHOOL_TEAM:FETCH', {
    pending: true
  }),
  team: createReducer(null, {
    'SCHOOL_TEAM:FETCH_REQUEST_SUCCESS': (state, { response }) => ({
      schoolId: response.data.school.id,
      pobble_school: response.data.school.pobble_school,
      teachers: normalizeTeachers(response.data.school.teacher_types),
      pending_teachers: normalizePendingTeachers(
        response.data.school.pending_teacher_types
      )
    }),
    'SCHOOL_TEAM:DELETE_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        teachers: {
          ...state.teachers,
          result: state.teachers.result.filter(id => id !== params.teacherId)
        }
      }
    },
    'SCHOOL_TEAM:DEMOTE_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        teachers: {
          ...state.teachers,
          entities: {
            teachers: {
              ...state.teachers.entities.teachers,
              [params.teacherId]: {
                ...state.teachers.entities.teachers[params.teacherId],
                school_leader: false
              }
            }
          }
        }
      }
    },
    'SCHOOL_TEAM:PROMOTE_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        teachers: {
          ...state.teachers,
          entities: {
            teachers: {
              ...state.teachers.entities.teachers,
              [params.teacherId]: {
                ...state.teachers.entities.teachers[params.teacherId],
                school_leader: true
              }
            }
          }
        }
      }
    },
    'SCHOOL_TEAM:APPROVE_REQUEST_SUCCESS': (state, { response, params }) => ({
      ...state,
      pending_teachers: {
        ...state.pending_teachers,
        result: state.pending_teachers.result.filter(
          id => id !== params.teacher.id
        )
      },
      teachers: {
        ...state.teachers,
        result: [params.teacher.id, ...state.teachers.result],
        entities: {
          teachers: {
            ...state.teachers.entities.teachers,
            [params.teacher.id]: {
              account: {
                id: params.teacher.id,
                full_name: params.teacher.name,
                email_identity: {
                  email: params.teacher.email
                }
              }
            }
          }
        }
      }
    }),
    'SCHOOL_TEAM:DISAPPROVE_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        pending_teachers: {
          ...state.pending_teachers,
          result: state.pending_teachers.result.filter(
            id => id !== params.teacherId
          )
        }
      }
    },
    'SCHOOL_TEAM:ADD_REQUEST_SUCCESS': (state, { response, params }) => {
      return {
        ...state,
        teachers: {
          ...state.teachers,
          result: [...state.teachers.result, response.data.account.id],
          entities: {
            teachers: {
              ...state.teachers.entities.teachers,
              [response.data.account.id]: {
                school_leader: response.data.account.teacher_type.school_leader,
                account: {
                  id: response.data.account.id,
                  full_name: response.data.account.full_name,
                  email_identity: {
                    email: params.teacher.email
                  }
                }
              }
            }
          }
        }
      }
    }
  })
})

export default SchoolTeam
